import TagTypeList, { TagTypeListProps } from './TagTypeList';

export type { TagTypeListProps };
export default TagTypeList;
